<template>
  <div>
    <v-overlay :value="loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar
      v-model="message.snackbar"
      :timeout="message.snackbarTimeout"
      bottom
    >
      {{ message.snackbarText }}
      <v-btn dark text @click="message.snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="collectUserDataDialog" scrollable max-width="600px">
      <v-card>
        <v-card-title>Bespoke question</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formCollectUserData">
            <v-radio-group v-model="collectUserData.questionType" row>
              <v-radio label="Question" value="QUESTION"></v-radio>
              <v-radio label="Pre question" value="PREQUESTION"></v-radio>
              <v-radio label="Employee" value="EMPLOYEE"></v-radio>
            </v-radio-group>
            <v-text-field
              v-model="collectUserData.label"
              label="Field name"
              :rules="[rules.required]"
              required
            ></v-text-field>
            <v-select
              v-if="collectUserData.questionType !== 'EMPLOYEE'"
              v-model="collectUserData.validation"
              multiple
              :items="validationChecks"
              :rules="[rules.required]"
              label="Validation check"
            ></v-select>
            <v-select
              v-model="collectUserData.fieldType"
              v-if="collectUserData.questionType !== 'EMPLOYEE'"
              :items="formTypes"
              :rules="[rules.required]"
              label="Dropdown, free text"
            ></v-select>
            <v-combobox
              v-if="collectUserData.fieldType == 'select'"
              v-model="collectUserData.select"
              label="Add select options"
              multiple
              chips
            ></v-combobox>
            <v-text-field
              v-if="
                collectUserData.fieldType !== 'checkbox' &&
                collectUserData.questionType == 'PREQUESTION'
              "
              v-model="collectUserData.success"
              label="Success value"
              :rules="[rules.required]"
              required
            ></v-text-field>
            <v-textarea
              v-if="
                collectUserData.fieldType !== 'checkbox' &&
                collectUserData.questionType == 'PREQUESTION'
              "
              v-model="collectUserData.error"
              label="Error message"
              :rules="[rules.required]"
            ></v-textarea>
            <v-checkbox
              v-model="collectUserData.internalUse"
              label="Internal Use"
            ></v-checkbox>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="collectUserDataDialog = false"
            class="hp--btn"
            >Close</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            @click="createCollectUserData()"
            text
            class="hp--btn"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="updateCollectUserDataDialog"
      scrollable
      max-width="600px"
    >
      <v-card>
        <v-card-title>Update bespoke question</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formUpdateCollectUserData">
            <v-radio-group
              v-model="collectUserData.questionType"
              :rules="[rules.required]"
              row
            >
              <v-radio label="Question" value="QUESTION"></v-radio>
              <v-radio label="Pre question" value="PREQUESTION"></v-radio>
              <v-radio label="Employee" value="EMPLOYEE"></v-radio>
            </v-radio-group>
            <v-text-field
              v-model="collectUserData.label"
              label="Field name"
              :rules="[rules.required]"
              required
            ></v-text-field>
            <v-select
              v-model="collectUserData.validation"
              multiple
              :items="validationChecks"
              :rules="[rules.required]"
              label="Validation check"
            ></v-select>
            <v-select
              v-if="collectUserData.questionType !== 'EMPLOYEE'"
              v-model="collectUserData.fieldType"
              :items="formTypes"
              :rules="[rules.required]"
              label="Dropdown, free text"
            ></v-select>
            <v-combobox
              v-if="collectUserData.fieldType == 'select'"
              v-model="collectUserData.select"
              label="Add select options"
              multiple
              chips
            ></v-combobox>
            <v-text-field
              v-if="
                collectUserData.fieldType !== 'checkbox' &&
                collectUserData.questionType == 'PREQUESTION'
              "
              v-model="collectUserData.success"
              label="Success value"
              :rules="[rules.required]"
              required
            ></v-text-field>
            <v-text-field
              v-if="collectUserData.questionType !== 'EMPLOYEE'"
              v-model="collectUserData.hint"
              label="Hint"
            ></v-text-field>
            <v-textarea
              v-if="collectUserData.questionType == 'PREQUESTION'"
              v-model="collectUserData.error"
              label="Error message"
              :rules="[rules.required]"
            ></v-textarea>
            <v-checkbox
              v-model="collectUserData.internalUse"
              label="Internal Use"
            ></v-checkbox>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="updateCollectUserDataDialog = false"
            >Close</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            @click="updateCollectUserData()"
            class="hp--btn"
            text
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="eventRoomDialog" scrollable max-width="600px">
      <v-card>
        <v-card-title>Room, date and time of event</v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <v-form ref="formCreateGroupEvent">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="eventGroupSlot.date"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-combobox
                  v-model="eventGroupSlot.date"
                  :rules="[rules.requiredArray]"
                  multiple
                  chips
                  small-chips
                  label="Choose date(s)"
                  prepend-icon="event"
                  readonly
                  color="primary"
                  v-on="on"
                ></v-combobox>
              </template>
              <v-date-picker
                v-model="eventGroupSlot.date"
                first-day-of-week="1"
                :min="minDateAllowed"
                multiple
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                  class="hp--btn"
                  >Cancel</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(eventGroupSlot.date)"
                  class="hp--btn"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-menu>

            <v-text-field
              v-model="eventGroupSlot.start"
              label="Start time"
              v-mask="'##:##'"
              :rules="[rules.required]"
              required
            ></v-text-field>

            <v-text-field
              v-model="eventGroupSlot.room"
              label="Room"
              :rules="[rules.required]"
              required
            ></v-text-field>

            <v-select
              v-if="computedLocationsSelectOptions.length > 1"
              v-model="eventGroupSlot.location"
              :items="computedLocationsSelectOptions"
              :rules="[rules.required]"
              label="Location"
            ></v-select>

            <v-select
              v-model="eventGroupSlot.assignedTo"
              :items="staff"
              :multiple="true"
              label="Assign to..."
            ></v-select>

            <v-checkbox
              v-model="eventGroupSlot.active"
              label="Active"
            ></v-checkbox>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            color="blue darken-1"
            text
            @click="eventRoomDialog = false"
            class="hp--btn"
            >Close</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            @click="createGroupSlots()"
            text
            class="hp--btn"
            >Save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="eventGroupDialog" scrollable max-width="500px">
      <v-card>
        <v-form ref="formUpdateGroupEvent">
          <v-card-title>Update room, date and time of event</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-menu
              v-model="eventDate"
              :close-on-content-click="false"
              max-width="290"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="computedDateFormattedMomentjs"
                  label="Date"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="eventGroup.date"
                first-day-of-week="1"
                @change="eventDate = false"
                :min="minDateAllowed"
              ></v-date-picker>
            </v-menu>
            <v-text-field
              v-model="eventGroup.room"
              label="Room"
              :rules="[rules.required]"
              required
            ></v-text-field>

            <v-select
              v-model="eventGroup.location"
              :items="computedLocationsSelectOptions"
              :rules="[rules.required]"
              label="Location"
            ></v-select>

            <v-select
              v-model="eventGroup.assignedTo"
              :items="staff"
              :multiple="true"
              label="Assign to..."
            ></v-select>

            <v-checkbox v-model="eventGroup.active" label="Active"></v-checkbox>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              color="blue darken-1"
              text
              @click="eventGroupDialog = false"
              class="hp--btn"
              >Close</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              @click="updateGroup(eventGroup.id)"
              class="hp--btn"
              text
              >Save</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="eventLocationDialog" scrollable max-width="500px">
      <v-form ref="formLocation">
        <v-card>
          <v-card-title>Add location</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-text-field
              v-model="location.addressLine1"
              label="Address line 1"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model="location.addressLine2"
              label="Address line 2"
              required
            ></v-text-field>
            <v-text-field
              v-model="location.town"
              label="Town/City"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model="location.postcode"
              label="Postcode"
              required
              :rules="[rules.required]"
            ></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              color="blue darken-1"
              text
              @click="eventLocationDialog = false"
              class="hp--btn"
              >Close</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              @click="createLocation"
              class="hp--btn"
              text
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="updateEventLocationDialog" scrollable max-width="500px">
      <v-form ref="formUpdateLocation">
        <v-card>
          <v-card-title>Edit location</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-text-field
              v-model="location.addressLine1"
              label="Address line 1"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model="location.addressLine2"
              label="Address line 2"
              required
            ></v-text-field>
            <v-text-field
              v-model="location.town"
              label="Town/City"
              required
              :rules="[rules.required]"
            ></v-text-field>
            <v-text-field
              v-model="location.postcode"
              label="Postcode"
              required
              :rules="[rules.required]"
            ></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              color="blue darken-1"
              text
              @click="updateEventLocationDialog = false"
              >Close</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              @click="updateLocation"
              text
              class="hp--btn"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step :complete="step > 1" step="1"
          >Create the event</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 2" step="2"
          >Bespoke questions</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 3" step="3"
          >Add the locations</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 4" step="4"
          >Create the slots</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step :complete="step > 5" step="5">Complete</v-stepper-step>
        <v-divider></v-divider>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-form ref="formEvent">
            <v-row>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="event.name"
                  label="Event name"
                  :rules="[rules.required]"
                  required
                ></v-text-field>

                <v-select
                  v-model="event.status"
                  :items="eventStatus"
                  label="Status"
                  :rules="[rules.required]"
                ></v-select>

                <v-text-field
                  v-model="event.bloodDropStart"
                  v-mask="'##:##'"
                  label="Blood drop in start time"
                  required
                ></v-text-field>

                <v-select
                  v-model="event.preQuestionTemplate"
                  multiple
                  :items="preQuestionTemplate"
                  label="Add pre-booking question template"
                ></v-select>

                <v-text-field
                  v-model="event.commsLink"
                  label="Comms link"
                ></v-text-field>

                <v-text-field
                  v-model="event.customAppointmentReminder"
                  v-mask="'###'"
                  label="Custom appointment reminder"
                  hint="If reminder required 30 minutes before appointment enter 30"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  v-model="event.code"
                  label="Code"
                  :rules="[rules.required]"
                  disabled
                ></v-text-field>
                <v-select
                  v-model="event.icalendar"
                  :items="iCalendar"
                  label="iCalendar messages"
                  :rules="[rules.required]"
                ></v-select>
                <v-text-field
                  v-model="event.bloodDropEnd"
                  v-mask="'##:##'"
                  label="Blood drop in end time"
                  required
                ></v-text-field>
                <v-select
                  v-model="event.clientAccess"
                  multiple
                  :items="clientAccessList"
                  label="Provide client access"
                ></v-select>
                <v-select
                  v-model="event.registerInterest"
                  :items="registerInterestEventList"
                  label="Show register interest if slots taken"
                ></v-select>
                <v-select
                  v-model="event.reminderTime"
                  :items="reminderOptions"
                  label="Reminder time interval"
                ></v-select>
              </v-col>

              <v-col cols="12" md="4">
                <v-select
                  v-model="event.type"
                  :items="eventTypes"
                  :rules="[rules.required]"
                  label="Type"
                  disabled
                ></v-select>
                <v-select
                  v-model="event.commsTemplate"
                  :items="commsTemplates"
                  label="Comms template"
                  :rules="[rules.required]"
                ></v-select>
                <v-text-field
                  v-model="event.urinePotLocation"
                  label="Urine pot location"
                  required
                ></v-text-field>
                <v-select
                  v-model="event.attendance"
                  :items="['No', 'Yes']"
                  label="Mark attendance"
                ></v-select>
                <v-select
                  v-model="event.notifyRegisterInterest"
                  :items="[
                    { text: 'Show message with link', value: 'message' },
                    {
                      text: 'Redirect to register interest',
                      value: 'redirect',
                    },
                  ]"
                  label="How to notify user of register interest"
                ></v-select>
              </v-col>

              <v-col cols="6">
                <v-textarea
                  v-model="event.message"
                  rows="3"
                  label="Message"
                ></v-textarea>
              </v-col>

              <v-col cols="6" style="padding-left: 12px">
                <v-textarea
                  v-model="event.description"
                  rows="3"
                  label="Description"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                :right="true"
                @click="createUpdateEvent()"
                class="hp--btn"
                >Continue</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-stepper-content>

        <v-stepper-content
          step="2"
          style="position: relative; min-height: 220px"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                class="mt-6 mr-4 hp--btn"
                color="blue"
                dark
                small
                absolute
                right
                top
                fab
                v-on="on"
                @click="
                  collectUserData = {};
                  openCollectData();
                "
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>New custom field</span>
          </v-tooltip>
          <v-card flat outlined>
            <v-list-item>
              <v-list-item-content>
                <div class="overline mb-4">CUSTOM DATA FIELDS</div>

                <v-card
                  flat
                  v-for="userdata in collectUserDatas"
                  :key="userdata.id"
                >
                  <v-divider></v-divider>
                  <v-layout row wrap class="ma-1">
                    <v-flex sm1>
                      <v-chip
                        small
                        class="mt-3 white--text"
                        color="blue"
                        v-if="userdata.questionType === 'EMPLOYEE'"
                        >EMP</v-chip
                      >
                      <v-chip
                        small
                        class="mt-3 white--text"
                        color="red"
                        v-if="userdata.questionType === 'PREQUESTION'"
                        >PRE</v-chip
                      >
                      <v-chip
                        small
                        class="mt-3 white--text"
                        color="green"
                        v-if="userdata.questionType === 'QUESTION'"
                        >QUE</v-chip
                      >
                    </v-flex>
                    <v-flex sm2 class="py-1 px-2">
                      <div class="caption grey--text">Field label</div>
                      {{ userdata.label }}
                    </v-flex>
                    <v-flex sm1 class="py-1">
                      <div class="caption grey--text">Field type</div>
                      {{ userdata.fieldType }}
                    </v-flex>
                    <v-flex sm3 class="py-1">
                      <div class="caption grey--text">Validation</div>
                      <v-chip
                        small
                        class="mr-1"
                        v-for="val in userdata.validation"
                        :key="val"
                        >{{ val }}</v-chip
                      >
                    </v-flex>
                    <v-flex sm3 class="py-1">
                      <div class="caption grey--text">Options</div>
                      <v-chip
                        small
                        class="mr-1"
                        v-for="opt in userdata.options"
                        :key="opt.id"
                        >{{ opt.options }}</v-chip
                      >
                    </v-flex>
                    <v-flex sm2 class="py-2">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="mx-2 float-right mr-3 hp--btn"
                            @click="deleteCollectUserData(userdata.id)"
                            fab
                            dark
                            x-small
                            color="error"
                          >
                            <v-icon v-on="on" dark>delete_outline</v-icon>
                          </v-btn>
                        </template>
                        <span>Delete custom fields</span>
                      </v-tooltip>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            class="mx-2 float-right hp--btn"
                            @click="openCustomDataFields(userdata.id)"
                            fab
                            dark
                            x-small
                            color="success"
                          >
                            <v-icon v-on="on" dark>edit</v-icon>
                          </v-btn>
                        </template>
                        <span>Update custom fields</span>
                      </v-tooltip>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-list-item-content>
            </v-list-item>
          </v-card>
          <v-card-actions>
            <v-btn
              color="primary"
              :right="true"
              @click="goToEvent()"
              class="hp--btn"
              >Back</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :right="true"
              @click="step = 3"
              class="hp--btn"
              >Continue</v-btn
            >
          </v-card-actions>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-data-table
            v-model="selectedLocations"
            :headers="locationHeaders"
            :items="locations"
            :single-select="false"
            item-key="id"
            show-select
            class="elevation-1"
          ></v-data-table>

          <v-card-actions>
            <v-btn
              color="primary"
              :right="true"
              @click="step = 2"
              class="hp--btn"
              >Back</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :right="true"
              @click="saveLocations()"
              class="hp--btn"
              >Continue</v-btn
            >
          </v-card-actions>
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-row>
            <v-col>
              <div class="text-center">
                <v-pagination
                  v-model="page"
                  :length="pageLength"
                  @input="getPagedEvents()"
                ></v-pagination>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <br />
          <v-row justify="space-around">
            <v-col cols="12" sm="12" md="4" lg="4">
              <v-card class="mx-auto" outlined>
                <br />
                <div class="text-center">
                  <v-btn
                    color="error"
                    fab
                    dark
                    class="ma-1"
                    @click="openEventLocation(5)"
                    >5</v-btn
                  >
                  <v-btn
                    color="pink lighten-1"
                    fab
                    dark
                    class="ma-1"
                    @click="openEventLocation(15)"
                    >15</v-btn
                  >
                  <v-btn
                    color="purple darken-1"
                    fab
                    dark
                    class="ma-1"
                    @click="openEventLocation(20)"
                    >20</v-btn
                  >
                  <v-btn
                    color="indigo lighten-1"
                    fab
                    dark
                    class="ma-1"
                    @click="openEventLocation(30)"
                    >30</v-btn
                  >
                  <v-btn
                    color="amber darken-1"
                    fab
                    dark
                    class="ma-1"
                    @click="openEventLocation(35)"
                    >35</v-btn
                  >
                  <v-btn
                    color="indigo accent-2"
                    fab
                    dark
                    class="ma-1"
                    @click="openEventLocation(45)"
                    >45</v-btn
                  >
                  <v-btn
                    color="cyan darken-2"
                    fab
                    dark
                    class="ma-1"
                    @click="openEventLocation(60)"
                    >60</v-btn
                  >
                  <v-btn
                    color="info"
                    fab
                    dark
                    class="ma-1"
                    @click="openEventLocation('custom')"
                  >
                    <v-icon>add</v-icon>
                  </v-btn>
                </div>
              </v-card>
            </v-col>

            <v-col cols="12" sm="12" md="8" lg="8">
              <div v-for="group in pagedSlotGroups" :key="group.id">
                <v-card flat class="pb-5" v-if="!group.filter">
                  <v-card class="mx-auto" outlined>
                    <v-list-item>
                      <v-list-item-content>
                        <v-row>
                          <v-col>
                            <div class="overline mb-4">SLOT</div>
                            <v-list-item-title class="headline mb-1"
                              >{{
                                new Date(group.date) | moment("Do MMMM YYYY")
                              }}
                              - {{ company.name }}</v-list-item-title
                            >
                            <v-list-item-subtitle
                              >{{ group.room }} - {{ group.addressLine1 }} ({{
                                group.town
                              }})</v-list-item-subtitle
                            >
                          </v-col>
                          <v-col>
                            <v-tooltip
                              v-for="assigned in group.assignedTo"
                              :key="assigned"
                              left
                            >
                              <template v-slot:activator="{ on }">
                                <v-avatar
                                  size="40"
                                  color="grey lighten-3"
                                  class="ma-2 float-right"
                                  v-on="on"
                                >
                                  <v-gravatar
                                    default-img="mp"
                                    :email="assigned"
                                  />
                                </v-avatar>
                              </template>
                              <span
                                >Assigned to
                                {{ getNameByEmail(assigned) }}</span
                              >
                            </v-tooltip>
                          </v-col>
                        </v-row>

                        <v-form :ref="`formSlotManagement${group.id}`">
                          <v-row>
                            <v-col md="3">
                              <v-text-field
                                v-model="eventGroupForm.start[group.id]"
                                label="Start"
                                v-mask="'##:##'"
                                :rules="[rules.required]"
                                required
                              ></v-text-field>
                            </v-col>

                            <v-col md="3">
                              <v-text-field
                                v-model="eventGroupForm.length[group.id]"
                                label="Duration (minutes)"
                                v-mask="'###'"
                                :rules="[rules.required]"
                                required
                              ></v-text-field>
                            </v-col>

                            <v-col md="6">
                              <v-btn
                                small
                                @click="createBreak(group.id)"
                                class="my-3 float-right"
                                >Add Break</v-btn
                              >
                              <v-btn
                                small
                                color="success"
                                @click="createSlot(group.id)"
                                class="my-3 mr-2 float-right"
                                >Add Slot</v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-form>

                        <v-card flat v-for="slot in group.slots" :key="slot.id">
                          <v-divider></v-divider>
                          <v-layout>
                            <v-flex xs3 sm2>
                              <v-avatar
                                v-if="slot.type == 'SLOT'"
                                :color="getSlotColour(slot.length)"
                                size="32"
                                class="ml-5 my-1"
                              >
                                <span class="white--text title">{{
                                  slot.length
                                }}</span>
                              </v-avatar>
                              <v-avatar
                                v-if="slot.type == 'BREAK'"
                                color="rgb(224, 224, 224)"
                                size="32"
                                class="ml-5 my-1"
                              >
                                <span class="title" color="rgba(0,0,0,.87)">{{
                                  slot.length
                                }}</span>
                              </v-avatar>
                              <v-avatar
                                v-if="slot.type == 'BLOOD'"
                                color="red"
                                size="32"
                                class="ml-5 my-1"
                              >
                                <span class="white--text title">{{
                                  slot.length
                                }}</span>
                              </v-avatar>
                            </v-flex>
                            <v-flex xs3 sm4 class="mt-3">
                              <div class="caption grey--text"></div>
                              {{ slot.time }}
                            </v-flex>
                            <v-flex xs3 sm4 class="py-1">
                              <v-chip
                                v-if="slot.type == 'SLOT' && slot.booked === 0"
                                color="orange"
                                class="white--text"
                              >
                                <v-avatar left>
                                  <v-icon color="white"
                                    >mdi-account-circle</v-icon
                                  >
                                </v-avatar>
                                {{ slot.type }}
                              </v-chip>

                              <v-tooltip
                                left
                                v-if="slot.type == 'SLOT' && slot.booked === 1"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-chip v-on="on" class="success">
                                    <v-avatar left>
                                      <v-icon color="white"
                                        >mdi-account-circle</v-icon
                                      >
                                    </v-avatar>
                                    {{ slot.type }}
                                  </v-chip>
                                </template>
                                <span
                                  >{{ slot.eventBooking.items[0].firstname }}
                                  {{
                                    slot.eventBooking.items[0].lastname
                                  }}</span
                                >
                              </v-tooltip>

                              <v-chip v-if="slot.type == 'BREAK'">
                                <v-icon class="mr-1">mdi-sleep</v-icon>
                                {{ slot.type }}
                              </v-chip>

                              <v-chip v-if="slot.type == 'BLOOD'" class="error">
                                <v-avatar left>
                                  <v-icon color="white"
                                    >mdi-invert-colors</v-icon
                                  >
                                </v-avatar>
                                {{ slot.type }}
                              </v-chip>
                            </v-flex>
                            <v-flex xs3 sm2>
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    @click="deleteSlot(group.id, slot.id)"
                                    fab
                                    dark
                                    x-small
                                    color="error"
                                    class="float-right mr-5 my-1"
                                  >
                                    <v-icon v-on="on" dark
                                      >delete_outline</v-icon
                                    >
                                  </v-btn>
                                </template>
                                <span>Delete slot</span>
                              </v-tooltip>
                            </v-flex>
                          </v-layout>
                        </v-card>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn icon>
                            <v-icon
                              @click="openEventLocation('copy', group.slots)"
                              class="hp--btn"
                              >content_copy</v-icon
                            >
                          </v-btn>
                          <v-btn icon>
                            <v-icon
                              @click="openUpdateEventDialog(group.id)"
                              class="hp--btn"
                              >edit</v-icon
                            >
                          </v-btn>
                          <v-btn
                            icon
                            @click="deleteGroupSlot(group.id)"
                            class="hp--btn"
                          >
                            <v-icon>delete</v-icon>
                          </v-btn>
                        </v-card-actions>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-card>
              </div>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-row>
            <v-col>
              <div class="text-center">
                <v-pagination
                  v-model="page"
                  :length="pageLength"
                  @input="getPagedEvents()"
                ></v-pagination>
              </div>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-btn
              color="primary"
              :right="true"
              @click="step = 3"
              class="hp--btn"
              >Back</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :right="true"
              @click="step = 5"
              class="hp--btn"
              >Complete</v-btn
            >
          </v-card-actions>
        </v-stepper-content>
        <v-stepper-content step="5">
          <v-layout text-center wrap>
            <v-flex xs12>
              <v-img
                :src="require('../assets/green-tick.png')"
                class="my-3"
                contain
                height="120"
              ></v-img>
            </v-flex>

            <v-flex xs12>
              <h1 class="display-1">
                {{ company.name }} ({{ event.code }}) appointments have been
                created!
              </h1>
            </v-flex>
            <v-flex xs12>
              <v-card class="grey lighten-4 ml-1 pa-5 my-5">
                <v-layout text-left wrap>
                  <v-row no-gutters style="flex-wrap: nowrap">
                    <v-col cols="12" class="flex-grow-0 flex-shrink-0">
                      <v-flex
                        xs12
                        class="headline red--text text--darken-4 my-5"
                        >The appointments created:</v-flex
                      >

                      <v-flex xs12 class="body-2">
                        <v-flex xs12 class="body-2">
                          <ul
                            v-for="group in computedSlotGroupDates"
                            :key="group"
                          >
                            <li class="body-1">
                              {{ new Date(group) | moment("Do MMMM YYYY") }}
                            </li>
                          </ul>
                        </v-flex>
                      </v-flex>
                    </v-col>
                  </v-row>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import moment from "moment";
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "./../graphql/queries";
import * as mutations from "./../graphql/mutations";
import { CustomField } from "../classes/CustomField";
import { hpUser } from "../classes/hpUser";
import { Slot } from "../classes/Slot";
import _ from "lodash";
export default {
  components: {},
  data() {
    return {
      step: 1,
      page: 1,
      maxSlots: 5,
      pageLength: 1,
      loader: false,
      showPassword: false,
      rules: {
        required: (v) => !!v || "This field is required.",
        min: (v) => (!!v && v.length >= 8) || "Min 8 characters",
        requiredArray: (v) => v.length > 0 || "This field is required.",
      },
      company: [],
      event: { clientAccess: [] },
      eventGroupSlot: {
        date: [],
        start: "08:00",
      },
      location: {},
      locations: [],
      eventLocations: [],
      selectedLocations: [],
      locationHeaders: [
        {
          text: "Address 1",
          align: "left",
          sortable: false,
          value: "addressLine1",
        },
        { text: "Address 2", value: "addressLine2" },
        { text: "Town", value: "town" },
        { text: "Postcode", value: "postcode" },
      ],
      slotGroups: [],
      copiedSlotGroups: [],
      pagedSlotGroups: [],
      collectUserData: { validation: {} },
      collectUserDatas: [],
      eventGroup: {
        date: new Date().toISOString().substr(0, 10),
        active: false,
      },
      hpUser: [],
      staff: [],
      eventTypes: [
        { text: "Slot", value: "slot" },
        { text: "Workshop", value: "workshop" },
        { text: "Register Interest", value: "register" },
        { text: "Health Screening", value: "healthscreening" },
        { text: "Virus Testing", value: "virustesting" },
      ],
      eventStatus: ["Draft", "Live", "Paused"],
      iCalendar: ["Yes", "No"],
      formTypes: [
        { text: "Checkbox", value: "checkbox" },
        { text: "Select", value: "select" },
        { text: "Text", value: "text" },
      ],
      validationChecks: [
        { text: "Required", value: "required" },
        { text: "Email", value: "email" },
      ],
      preQuestionTemplate: [
        { text: "Flu questions", value: "fluQuestions" },
        { text: "Covid questions", value: "covidQuestions" },
      ],
      reminderOptions: [
        { text: "24 hour reminder (default)", value: "24" },
        { text: "48 hour reminder", value: "48" }
      ],
      clientAccessList: [],
      registerInterestEventList: [],
      commsTemplates: [],
      eventLocationDialog: false,
      updateEventLocationDialog: false,
      eventRoomDialog: false,
      eventGroupDialog: false,
      collectUserDataDialog: false,
      updateCollectUserDataDialog: false,
      date: new Date().toISOString().substr(0, 10),
      eventDate: false,
      eventGroupDate: false,
      eventGroupForm: {
        start: [],
        end: [],
        length: [],
      },
      room: "",
      begins: "",
      start: "",
      end: "",
      length: "",
      menu: false,
      questionFabMenu: false,
      minDateAllowed: moment().toISOString(),
      message: {
        snackbar: false,
        snackbarText: "",
        snackbarTimeout: 3000,
      },
      baseUri: window.location.origin,
    };
  },
  created() {
    this.getEventDetails();
  },
  methods: {
    openEventLocation(slot, groupSlots = null) {
      this.eventGroupSlot = { date: [], start: "08:00", active: true };
      this.event.slot = slot;
      this.eventRoomDialog = true;
      if (this.event.slot === "copy") {
        this.copiedSlotGroups = groupSlots;
      }
    },
    openCollectData() {
      this.collectUserDataDialog = true;
    },
    openAddressDialog() {
      this.location = [];
      this.eventLocationDialog = true;
    },
    openUpdateEventDialog(groupId) {
      if (groupId) {
        // Update event
        API.graphql(
          graphqlOperation(queries.getEventSlotGroup, {
            id: groupId,
          })
        ).then(result => {
          this.eventGroup.id = result.data.getEventSlotGroup.id;
          this.eventGroup.date = new Date(result.data.getEventSlotGroup.date)
            .toISOString()
            .substr(0, 10);
          this.eventGroup.room = result.data.getEventSlotGroup.room;
          this.eventGroup.assignedTo = JSON.parse(
            result.data.getEventSlotGroup.assignedTo
          );
          this.eventGroup.location =
            result.data.getEventSlotGroup.eventLocation.id;
          this.eventGroup.active = result.data.getEventSlotGroup.active;
          this.eventGroupDialog = true;
        });
      }
    },
    async openCustomDataFields(id) {
      if (id) {
        const collectUserData = await CustomField.getCustomFields(id);
        let collectUserDataOptions = collectUserData.eventCollectUserDataOptions.items.map(
          item => item.options
        );
        collectUserDataOptions = collectUserDataOptions.sort();

        this.collectUserData = {
          id: collectUserData.id,
          label: collectUserData.label,
          questionType: collectUserData.questionType,
          validation: collectUserData.validation,
          fieldType: collectUserData.fieldType,
          internalUse: collectUserData.internalUse,
          success: collectUserData.success,
          hint: collectUserData.hint,
          error: collectUserData.error,
          isDeleted: collectUserData.isDeleted,
          select: collectUserDataOptions,
        };
        this.updateCollectUserDataDialog = true;
      }
    },
    orderSlotGroup() {
      this.slotGroups.sort((a, b) => new Date(a.date) - new Date(b.date));
      for (var i = 0; i < this.slotGroups.length; i++) {
        if (this.slotGroups[i].slots.length > 0) {
          this.slotGroups[i].slots.sort(
            (a, b) =>
              new Date("1970/01/01 " + a.time.substring(0, 5)) -
              new Date("1970/01/01 " + b.time.substring(0, 5))
          );
        }
      }
    },
    getEventDetails() {
      this.loader = true;
      this.slotGroups = [];
      this.pagedSlotGroups = [];
      this.eventLocations = [];
      this.collectUserDatas = [];
      const getEvent = `query GetEvent($id: ID!) {
            getEvent(id: $id) {
                id
                name
                code
                type
                requireDob
                iCalendar
                attendance
                status
                message
                description
                bloodDropStart
                bloodDropEnd
                urinePotLocation
                commsTemplate
                preQuestionTemplate
                clientAccess
                registerInterest
                notifyRegisterInterest
                commsLink
                customAppointmentReminder
                reminderTime
                createdAt
                eventCompany {
                  id
                  name
                  createdAt
                  isDeleted
                  eventClientAccess {
                    items {
                      id
                      description
                    }
                  }
                }
                eventLocation (
                  filter: {
                      isDeleted: { eq: 0 }
                  }
                ) {
                    items {
                        id
                        addressLine1
                        addressLine2
                        town
                        postcode
                        eventLocationLookupId
                        createdAt
                        isDeleted
                        eventSlotGroup(
                          limit: 1000
                          filter: {
                              isDeleted: { eq: 0 }
                          }
                        ) {
                            items {
                                id
                                room
                                date
                                assignedTo
                                active
                                createdAt
                                eventSlot(
                                  limit: 1000
                                  filter: {
                                      isDeleted: { eq: 0 }
                                  }
                                ) {
                                    items {
                                        id
                                        length
                                        time
                                        type
                                        booked
                                        eventBooking(
                                          filter: {
                                            isDeleted: { eq: 0 }
                                          },
                                          limit: 1000
                                        ) {
                                            items {
                                              id
                                              firstname
                                              lastname
                                            }
                                        }
                                    }
                                    nextToken
                                }
                            }
                            nextToken
                        }
                    }
                    nextToken
                }
                eventCollectUserData(
                  filter: {
                      isDeleted: { eq: 0 }
                  }
                ) {
                  items {
                    id
                    label
                    questionType
                    validation
                    fieldType
                    internalUse
                    success
                    error
                    createdAt
                    isDeleted
                    eventCollectUserDataOptions {
                      items {
                        id
                        options
                      }
                    }
                  }
                }
            }
        }
      `;
      API.graphql(
        graphqlOperation(getEvent, {
          id: this.$route.params.eventId,
        })
      ).then(result => {
        const that = this;
        const event = result.data.getEvent;
        this.company = event.eventCompany;
        event.eventCompany.eventClientAccess.items.forEach(function(
          clientAccess
        ) {
          that.clientAccessList.push({
            text: clientAccess.description,
            value: clientAccess.id,
          });
          that.clientAccess = _.orderBy(
            that.clientAccess,
            "description",
            "asc"
          );
        });

        this.event = {
          id: event.id,
          code: event.code,
          createdAt: event.createdAt,
          name: event.name,
          type: event.type,
          booked: event.booked,
          commsTemplate: event.commsTemplate,
          bloodDropStart: event.bloodDropStart,
          bloodDropEnd: event.bloodDropEnd,
          commsLink: event.commsLink,
          customAppointmentReminder: event.customAppointmentReminder,
          reminderTime: event.reminderTime ? event.reminderTime : "24",
          urinePotLocation: event.urinePotLocation,
          preQuestionTemplate: event.preQuestionTemplate,
          icalendar: event.iCalendar ? "Yes" : "No",
          attendance: event.attendance ? "Yes" : "No",
          status: event.status,
          message: event.message,
          description: event.description,
          clientAccess: event.clientAccess,
          registerInterest: event.registerInterest,
          notifyRegisterInterest: event.notifyRegisterInterest,
        };

        event.eventLocation.items.forEach(function(location) {
          location.eventSlotGroup.items.forEach(function(group) {
            let slots = group.eventSlot.items;
            // slots = slots.map((slot) => {
            //   let colour = that.getSlotColour(slot.length);
            //   return { ...slot, ...colour };
            // });
            let sorted = slots.sort(
              (a, b) =>
                new Date("1970/01/01 " + a.time.substring(0, 5)) -
                new Date("1970/01/01 " + b.time.substring(0, 5))
            );
            that.slotGroups.push({
              id: group.id,
              room: group.room.trim(),
              addressLine1: location.addressLine1.trim(),
              town: location.town.trim(),
              date: group.date,
              assignedTo: JSON.parse(group.assignedTo),
              active: group.active,
              createdAt: group.createdAt,
              slots: sorted,
              filter: false,
            });
          });

          that.eventLocations.push({
            id: location.id,
            addressLine1: location.addressLine1,
            addressLine2: location.addressLine2,
            town: location.town,
            postcode: location.postcode,
            eventLocationLookupId: location.eventLocationLookupId,
          });
        });
        this.orderSlotGroup();
        this.pageLength = Math.ceil(this.slotGroups.length / this.maxSlots);
        this.pagedSlotGroups = this.slotGroups.slice(0, this.maxSlots);

        event.eventCollectUserData.items.forEach(function(collectUserData) {
          that.collectUserDatas.push({
            id: collectUserData.id,
            label: collectUserData.label,
            questionType: collectUserData.questionType,
            validation: collectUserData.validation,
            fieldType: collectUserData.fieldType,
            internalUse: collectUserData.internalUse ? true : false, //collectUserData.internalUse ? true : false,
            success: collectUserData.success,
            hint: collectUserData.hint,
            error: collectUserData.error,
            options: _.orderBy(
              collectUserData.eventCollectUserDataOptions.items,
              "options",
              "asc"
            )
          });
        });
        that.collectUserDatas = _.orderBy(
          that.collectUserDatas,
          "label",
          "asc"
        );
        this.commsTemplatesSelect();
        this.locationLookup();
        this.getUsers();
        this.getRegisterInterestEvents();
        this.loader = false;
      });
    },
    getRegisterInterestEvents() {
      const that = this;
      const getEventCompany = `query GetEventCompany($id: ID!) {
        getEventCompany(id: $id) {
          event(
            filter: {
              isDeleted: { eq: 0 },
              type: { eq: "register" }
            }
          ) {
            items {
              id
              name
            }
          }
        }
      }
    `;

      API.graphql(
        graphqlOperation(getEventCompany, {
          id: this.company.id,
        })
      ).then((result) => {
        result.data.getEventCompany.event.items.forEach(function (event) {
          that.registerInterestEventList.push({
            text: event.name,
            value: event.id,
          });
        });
        that.registerInterestEventList = _.orderBy(
          that.registerInterestEventList,
          "name",
          "asc"
        ); // Lodash sort
      });
    },
    async createCollectUserData() {
      if (this.$refs.formCollectUserData.validate()) {
        let that = this;
        if (this.collectUserData.questionType === "EMPLOYEE") {
          this.collectUserData.fieldType = "text";
          this.collectUserData.validation = [];
          this.collectUserData.validation.push("required");
        }

        const collectUserData = await CustomField.createBespokeQuestion(
          this.event.id,
          this.collectUserData
        );

        that.collectUserDatas.push({
          id: collectUserData.id,
          questionType: collectUserData.questionType,
          label: collectUserData.label,
          validation: collectUserData.validation,
          fieldType: collectUserData.fieldType,
          internalUse: collectUserData.internalUse ? true : false,
          success: that.collectUserData.success,
          hint: that.collectUserData.hint,
          error: that.collectUserData.error,
          options: []
        });

        if (
          that.collectUserData.select !== undefined &&
          that.collectUserData.fieldType === "select"
        ) {
          that.collectUserData.select.forEach(function (option) {
            API.graphql(
              graphqlOperation(mutations.createEventCollectUserDataOptions, {
                input: {
                  options: option,
                  eventCollectUserDataOptionsEventCollectUserDataId:
                    collectUserData.id,
                  isDeleted: 0,
                }
              })
            ).then(result => {
              that.collectUserDatas[
                that.collectUserDatas.length - 1
              ].options.push({
                id: result.data.createEventCollectUserDataOptions.id,
                options: result.data.createEventCollectUserDataOptions.options,
              });
            });
          });
        }
        that.collectUserDataDialog = false;
      }
    },
    updateCollectUserData() {
      const that = this;
      if (that.$refs.formUpdateCollectUserData.validate()) {
        const updateEventCollectUserData = /* GraphQL */ `
          mutation UpdateEventCollectUserData(
            $input: UpdateEventCollectUserDataInput!
            $condition: ModelEventCollectUserDataConditionInput
          ) {
            updateEventCollectUserData(input: $input, condition: $condition) {
              id
              label
              questionType
              validation
              fieldType
              internalUse
              createdAt
              success
              error
              hint
              isDeleted
              eventCollectUserDataOptions {
                items {
                  id
                  options
                  isDeleted
                }
              }
            }
          }
        `;
        API.graphql(
          graphqlOperation(updateEventCollectUserData, {
            input: {
              id: that.collectUserData.id,
              questionType: that.collectUserData.questionType,
              label: that.collectUserData.label,
              validation: that.collectUserData.validation,
              fieldType: that.collectUserData.fieldType,
              internalUse: that.collectUserData.internalUse,
              success: that.collectUserData.success,
              hint: that.collectUserData.hint,
              error: that.collectUserData.error
            }
          })
        ).then(result => {
          const collectUserData = result.data.updateEventCollectUserData;
          collectUserData.eventCollectUserDataOptions.items.forEach(function (
            option
          ) {
            API.graphql(
              graphqlOperation(mutations.deleteEventCollectUserDataOptions, {
                input: {
                  id: option.id
                }
              })
            );
          });
          const index = that.collectUserDatas.findIndex(
            data => data.id === collectUserData.id
          );

          that.collectUserDatas[index] = {
            id: collectUserData.id,
            questionType: collectUserData.questionType,
            label: collectUserData.label,
            validation: collectUserData.validation,
            fieldType: collectUserData.fieldType,
            internalUse: that.collectUserData.internalUse,
            success: collectUserData.success,
            options: []
          };

          if (
            that.collectUserData.select !== undefined &&
            that.collectUserData.fieldType === "select"
          ) {
            let options = [];
            that.collectUserData.select.forEach(function (option) {
              API.graphql(
                graphqlOperation(mutations.createEventCollectUserDataOptions, {
                  input: {
                    options: option.trim(),
                    eventCollectUserDataOptionsEventCollectUserDataId:
                      collectUserData.id,
                    isDeleted: 0,
                  },
                })
              ).then(result => {
                options.push({
                  id: result.data.createEventCollectUserDataOptions.id,
                  options: result.data.createEventCollectUserDataOptions.options.trim(),
                  isDeleted: 0
                });

                that.collectUserDatas[index].options = options;
              });
            });
          }
          that.updateCollectUserDataDialog = false;
        });
      }
    },
    async nextCommsTemplate(nextToken) {
      const {
        data: { listEventCommsTemplates: templates },
      } = await API.graphql({
        query: queries.listEventCommsTemplates,
        variables: {
          limit: 100,
          filter: { isDeleted: { eq: 0 } },
          nextToken: nextToken,
        },
      });
      return templates;
    },
    async commsTemplatesSelect() {
      var that = this;
      let templates = await this.nextCommsTemplate(null);
      let templateItems = templates.items;
      while (templates.nextToken !== null) {
        templates = await this.nextCommsTemplate(templates.nextToken);
        templateItems.push(...templates.items);
      }
      const templatelist = templateItems.map((template) => ({
        text: template.name,
        value: template.id,
      }));
      that.commsTemplates = _.orderBy(templatelist, "text", "asc");
    },
    locationLookup() {
      const that = this;
      that.selectedLocations = [];
      that.locations = [];
      const lookup = `query GetEventCompany($id: ID!) {
              getEventCompany(id: $id) {
                eventLocationLookup(filter: {isDeleted: {eq: 0}}) {
                  items {
                    id
                    postcode
                    town
                    addressLine1
                    addressLine2
                    createdAt
                    isDeleted
                  }
                }
              }
            }`;
      // Update event
      API.graphql(
        graphqlOperation(lookup, {
          id: this.company.id,
        })
      ).then((result) => {
        const locationLookups =
          result.data.getEventCompany.eventLocationLookup.items;

        locationLookups.forEach(function (locationLookup) {
          that.locations.push({
            id: locationLookup.id,
            addressLine1: locationLookup.addressLine1,
            addressLine2: locationLookup.addressLine2,
            town: locationLookup.town,
            postcode: locationLookup.postcode,
          });
          that.eventLocations.forEach(function (location) {
            if (locationLookup.id === location.eventLocationLookupId) {
              that.selectedLocations.push({
                id: locationLookup.id,
                postcode: locationLookup.postcode,
                town: locationLookup.town,
                addressLine1: locationLookup.addressLine1,
                addressLine2: locationLookup.addressLine2,
                createdAt: locationLookup.createdAt,
                isDeleted: locationLookup.isDeleted,
                eventLocationId: location.id,
              });
            }
          });
        });
      });
    },
    getPagedEvents() {
      this.loader = true;
      const pageStart = parseInt((this.page - 1) * this.maxSlots);
      const pageEnd = parseInt(pageStart + this.maxSlots);
      this.pagedSlotGroups = this.slotGroups.slice(pageStart, pageEnd);
      this.loader = false;
    },
    async createLocation() {
      if (this.$refs.formLocation.validate()) {
        API.graphql(
          graphqlOperation(mutations.createEventLocation, {
            input: {
              addressLine1: this.location.addressLine1,
              addressLine2: this.location.addressLine2,
              town: this.location.town,
              postcode: this.location.postcode,
              createdAt: new Date().toISOString(),
              eventLocationEventId: this.event.id,
              isDeleted: 0,
            },
          })
        ).then((result) => {
          this.locations.push({
            id: result.data.createEventLocation.id,
            addressLine1: result.data.createEventLocation.addressLine1,
            addressLine2: result.data.createEventLocation.addressLine2,
            town: result.data.createEventLocation.town,
            postcode: result.data.createEventLocation.postcode,
          });
          this.eventLocationDialog = false;
        });
      }
    },
    async saveLocations() {
      const that = this;

      const getEvent = `query GetEvent($id: ID!, $eventLocationLookupId: String!) {
        getEvent(id: $id) {
          eventLocation(filter: {isDeleted: {eq: 0}, eventLocationLookupId: {eq: $eventLocationLookupId}}) {
            items {
              id
              isDeleted
              postcode
              town
              eventLocationLookupId
              createdAt
              addressLine2
              addressLine1
            }
          }
        }
      }
      `;

      that.selectedLocations.forEach(function (location) {
        API.graphql(
          graphqlOperation(getEvent, {
            id: that.event.id,
            eventLocationLookupId: location.id,
          })
        ).then((result) => {
          if (result.data.getEvent.eventLocation.items.length === 0) {
            API.graphql(
              graphqlOperation(mutations.createEventLocation, {
                input: {
                  addressLine1: location.addressLine1,
                  addressLine2: location.addressLine2,
                  town: location.town,
                  postcode: location.postcode,
                  createdAt: new Date().toISOString(),
                  eventLocationLookupId: location.id,
                  eventLocationEventId: that.event.id,
                  isDeleted: 0,
                },
              })
            ).then((result) => {
              const location = result.data.createEventLocation;
              that.eventLocations.push(location);
            });
          } else {
            // Compare
            let isComparable = that.compareAddressLocations(
              location,
              result.data.getEvent.eventLocation.items[0]
            );
            if (!isComparable) {
              API.graphql(
                graphqlOperation(mutations.updateEventLocation, {
                  input: {
                    id: result.data.getEvent.eventLocation.items[0].id,
                    addressLine1: location.addressLine1,
                    addressLine2: location.addressLine2,
                    town: location.town,
                    postcode: location.postcode,
                  },
                })
              ).then((result) => {
                const location = result.data.updateEventLocation;
                that.eventLocations.push(location);
              });
            }
          }
          that.step = 4;
        });
      });
    },
    async updateLocation() {
      if (this.$refs.formUpdateLocation.validate()) {
        API.graphql(
          graphqlOperation(mutations.updateEventLocation, {
            input: {
              id: this.location.id,
              addressLine1: this.location.addressLine1,
              addressLine2: this.location.addressLine2,
              town: this.location.town,
              postcode: this.location.postcode,
              createdAt: new Date().toISOString(),
              eventLocationEventId: this.event.id,
              isDeleted: 0,
            },
          })
        ).then((result) => {
          const location = result.data.updateEventLocation;
          const index = this.locations.findIndex(
            (loc) => loc.id === location.id
          );
          this.locations[index] = {
            id: location.id,
            addressLine1: location.addressLine1,
            addressLine2: location.addressLine2,
            town: location.town,
            postcode: location.postcode,
          };
          this.updateEventLocationDialog = false;
        });
      }
    },
    async createSlot(id) {
      let that = this;
      if (that.$refs["formSlotManagement" + id][0].validate()) {
        const index = that.slotGroups.findIndex((grp) => grp.id === id);
        let startTime = that.eventGroupForm.start[id];
        let duration = parseInt(that.eventGroupForm.length[id]);
        let endTime = moment(startTime, "HH:mm")
          .add(duration, "minutes")
          .format("HH:mm");
        if (that.slotGroups[index].id === id) {
          let slotBatches = [];
          slotBatches.push({
            time: startTime + " - " + endTime,
            length: duration,
            type: "SLOT",
            eventSlotEventSlotGroupId: id,
            booked: 0,
            isDeleted: 0,
          });

          const createBatchEventSlot = (batch) => {
            return new Promise(async (resolve) => {
              API.graphql(
                graphqlOperation(mutations.createBatchEventSlot, {
                  slots: batch,
                })
              ).then((result) => {
                resolve(result.data.createBatchEventSlot);
              });
            });
          };

          // Run slot batches
          const createdSlots = await Promise.all(
            slotBatches.map(async (batch) => await createBatchEventSlot(batch))
          );
          if (createdSlots.length > 0) {
            createdSlots[0].map((slot) => {
              // let colour = that.getSlotColour(slot.length);
              that.slotGroups[index].slots.push({
                id: slot.id,
                start: this.eventGroupForm.start[id],
                end: this.eventGroupForm.end[id],
                time: slot.time,
                length: slot.length,
                type: slot.type,
                booked: slot.booked,
                // colour: colour.colour,
              });
              that.slotGroups[index].slots.sort(
                (a, b) =>
                  new Date("1970/01/01 " + a.time.substring(0, 5)) -
                  new Date("1970/01/01 " + b.time.substring(0, 5))
              );
              that.eventGroupForm.start[id] = endTime;
              this.showSuccessMessage("New slot created");
            });
          }
        }
      }
    },
    async createBreak(id) {
      let that = this;

      if (that.$refs["formSlotManagement" + id][0].validate()) {
        const index = that.slotGroups.findIndex((grp) => grp.id === id);
        let startTime = that.eventGroupForm.start[id];
        let duration = parseInt(that.eventGroupForm.length[id]);
        let endTime = moment(startTime, "HH:mm")
          .add(duration, "minutes")
          .format("HH:mm");

        if (that.slotGroups[index].id === id) {
          let slotBatches = [];
          slotBatches.push({
            time: startTime + " - " + endTime,
            length: duration,
            type: "BREAK",
            eventSlotEventSlotGroupId: id,
            booked: 0,
            isDeleted: 0,
          });

          const createBatchEventSlot = (batch) => {
            return new Promise(async (resolve) => {
              API.graphql(
                graphqlOperation(mutations.createBatchEventSlot, {
                  slots: batch,
                })
              ).then((result) => {
                resolve(result.data.createBatchEventSlot);
              });
            });
          };

          // Run slot batches
          const createdSlots = await Promise.all(
            slotBatches.map(async (batch) => await createBatchEventSlot(batch))
          );
          if (createdSlots.length > 0) {
            createdSlots[0].map((slot) => {
              that.slotGroups[index].slots.push({
                id: slot.id,
                start: this.eventGroupForm.start[id],
                end: this.eventGroupForm.end[id],
                time: slot.time,
                length: slot.length,
                type: slot.type,
                booked: slot.booked,
              });
              that.slotGroups[index].slots.sort(
                (a, b) =>
                  new Date("1970/01/01 " + a.time.substring(0, 5)) -
                  new Date("1970/01/01 " + b.time.substring(0, 5))
              );
              that.eventGroupForm.start[id] = endTime;
              this.showSuccessMessage("New break created");
            });
          }
        }
      }
    },
    async createUpdateEvent() {
      if (this.$refs.formEvent.validate()) {
        if (this.event.id) {
          API.graphql(
            graphqlOperation(mutations.updateEvent, {
              input: {
                id: this.event.id,
                name: this.event.name,
                // code: this.event.code.toLowerCase(),
                type: this.event.type,
                requireDob: this.event.requireDob === "Yes" ? true : false,
                iCalendar: this.event.icalendar === "Yes" ? true : false,
                attendance: this.event.attendance === "Yes" ? true : false,
                status: this.event.status,
                message: this.event.message ? this.event.message : null,
                description: this.event.description
                  ? this.event.description
                  : null,
                createdAt: new Date().toISOString(),
                commsTemplate: this.event.commsTemplate,
                bloodDropStart: this.event.bloodDropStart,
                bloodDropEnd: this.event.bloodDropEnd,
                commsLink: this.event.commsLink,
                customAppointmentReminder: this.event.customAppointmentReminder,
                reminderTime: this.event.reminderTime,
                urinePotLocation: this.event.urinePotLocation,
                preQuestionTemplate: this.event.preQuestionTemplate,
                eventEventCompanyId: this.company.id,
                clientAccess: this.event.clientAccess,
                registerInterest: this.event.registerInterest,
                notifyRegisterInterest: this.event.notifyRegisterInterest,
              },
            })
          ).then((result) => {
            const eventResult = result.data.updateEvent;
            this.event = {
              id: eventResult.id,
              code: eventResult.code.toLowerCase(),
              name: eventResult.name,
              requireDob: eventResult.requireDob,
              commsTemplate: eventResult.commsTemplate,
              bloodDropStart: eventResult.bloodDropStart,
              bloodDropEnd: eventResult.bloodDropEnd,
              commsLink: eventResult.commsLink,
              customAppointmentReminder: eventResult.customAppointmentReminder,
              reminderTime: eventResult.reminderTime,
              urinePotLocation: eventResult.urinePotLocation,
              type: eventResult.type === "yes" ? true : false,
              icalendar: eventResult.icalendar === "yes" ? true : false,
              attendance: eventResult.attendance === "yes" ? true : false,
              registerInterest: eventResult.registerInterest,
              notifyRegisterInterest: eventResult.notifyRegisterInterest,
              status: eventResult.status,
            };
            this.step = 2;
          });
        } else {
          // Create event
          API.graphql(
            graphqlOperation(mutations.createEvent, {
              input: {
                name: this.event.name,
                code: this.event.code.toLowerCase(),
                type: this.event.type,
                requireDob: true,
                createdAt: new Date().toISOString(),
                eventEventCompanyId: this.company.id,
              },
            })
          ).then((result) => {
            const eventResult = result.data.createEvent;
            this.event = {
              id: eventResult.id,
              code: eventResult.code.toLowerCase(),
              name: eventResult.name,
              requireDob: eventResult.requireDob,
              type: eventResult.type,
            };
            this.step = 2;
          });
        }
      }
    },
    goToEvent() {
      this.getEventDetails();
      this.step = 1;
    },
    async createGroupSlots() {
      if (this.$refs.formCreateGroupEvent.validate()) {
        let that = this;
        let location = that.eventGroupSlot.location;
        if (!location) {
          // 1 location
          location = this.computedLocationsSelectOptions[0].value;
        }

        this.eventRoomDialog = false;
        this.loader = true;

        let slot = new Slot({
          room: that.eventGroupSlot.room,
          capacity: 1,
          assignedTo: JSON.stringify(that.eventGroupSlot.assignedTo),
          start: that.eventGroupSlot.start,
          end: that.eventGroupSlot.end,
          dates: that.eventGroupSlot.date,
          active: that.eventGroupSlot.active,
          location: location,
          type: "SLOT",
          slot: that.event.slot,
          bloodDropStart: that.event.bloodDropStart,
          bloodDropEnd: that.event.bloodDropEnd,
          copiedSlotGroups: that.copiedSlotGroups,
        });

        const eventSlotGroup = await slot.reserveBookingSlot();
        eventSlotGroup.forEach(async (group) => {
          that.slotGroups.push(group);
        });
        that.orderSlotGroup();
        this.pageLength = Math.ceil(this.slotGroups.length / this.maxSlots);
        const pageStart = parseInt((this.page - 1) * this.maxSlots);
        const pageEnd = parseInt(pageStart + this.maxSlots);
        this.pagedSlotGroups = this.slotGroups.slice(pageStart, pageEnd);
        this.loader = false;
        this.eventRoomDialog = false;
        this.showSuccessMessage("New slot created");
      }
    },
    async deleteSlot(groupId, id) {
      if (confirm("Are you sure you want to delete this slot?")) {
        const deleteEventSlot = `mutation DeleteEventSlot(
        $input: DeleteEventSlotInput!
        $condition: ModelEventSlotConditionInput
      ) {
        deleteEventSlot(input: $input, condition: $condition) {
          id
          time
        }
      }`;

        API.graphql(
          graphqlOperation(deleteEventSlot, {
            input: { id: id },
          })
        ).then((result) => {
          for (var i = 0; i < this.slotGroups.length; i++) {
            if (this.slotGroups[i].id === groupId) {
              this.slotGroups[i].slots = this.slotGroups[i].slots.filter(
                (slot) => slot.id !== result.data.deleteEventSlot.id
              );
            }
          }
          this.showSuccessMessage(
            `Slot ${result.data.deleteEventSlot.time} deleted`
          );
        });
      }
    },
    updateGroup() {
      if (this.$refs.formUpdateGroupEvent.validate()) {
        API.graphql(
          graphqlOperation(mutations.updateEventSlotGroup, {
            input: {
              id: this.eventGroup.id,
              room: this.eventGroup.room,
              date: this.eventGroup.date,
              eventSlotGroupEventLocationId: this.eventGroup.location,
              assignedTo: JSON.stringify(this.eventGroup.assignedTo),
              active: this.eventGroup.active,
            },
          })
        ).then((result) => {
          const index = this.slotGroups.findIndex(
            (grp) => grp.id === result.data.updateEventSlotGroup.id
          );
          this.slotGroups[index].room = result.data.updateEventSlotGroup.room;
          this.slotGroups[index].addressLine1 =
            result.data.updateEventSlotGroup.eventLocation.addressLine1;
          this.slotGroups[index].town =
            result.data.updateEventSlotGroup.eventLocation.town;
          this.slotGroups[index].date = result.data.updateEventSlotGroup.date;
          this.slotGroups[index].assignedTo = JSON.parse(
            result.data.updateEventSlotGroup.assignedTo
          );
          this.slotGroups[index].active =
            result.data.updateEventSlotGroup.active;
          this.eventGroupDialog = false;
          this.showSuccessMessage("Slot updated");
        });
      }
    },
    editLocation(id) {
      if (id) {
        API.graphql(
          graphqlOperation(queries.getEventLocation, {
            id: id,
          })
        ).then((result) => {
          const eventLocation = result.data.getEventLocation;
          this.location.id = eventLocation.id;
          this.location.addressLine1 = eventLocation.addressLine1;
          this.location.addressLine2 = eventLocation.addressLine2;
          this.location.town = eventLocation.town;
          this.location.postcode = eventLocation.postcode;
          this.updateEventLocationDialog = true;
        });
      }
    },
    deleteLocation(id) {
      if (id) {
        API.graphql(
          graphqlOperation(mutations.updateEventLocation, {
            input: {
              id: id,
              isDeleted: 1,
            },
          })
        ).then((result) => {
          this.locations = this.locations.filter(
            (location) => location.id !== result.data.updateEventLocation.id
          );
        });
      }
    },
    deleteGroupSlot(id) {
      if (confirm("Are you sure you want to delete ALL the slots?")) {
        if (id) {
          this.loader = true;
          API.graphql(
            graphqlOperation(mutations.updateEventSlotGroup, {
              input: {
                id: id,
                isDeleted: 1,
              },
            })
          ).then((result) => {
            this.pagedSlotGroups = this.pagedSlotGroups.filter(
              (group) => group.id !== result.data.updateEventSlotGroup.id
            );
            this.slotGroups = this.pagedSlotGroups;
            this.loader = false;
            this.showSuccessMessage("Group slot deleted");
          });
        }
      }
    },
    deleteCollectUserData(id) {
      if (confirm("Are you sure you want to delete the custom data field?")) {
        if (id) {
          API.graphql(
            graphqlOperation(mutations.updateEventCollectUserData, {
              input: {
                id: id,
                isDeleted: 1,
              },
            })
          ).then((result) => {
            this.collectUserDatas = this.collectUserDatas.filter(
              (data) => data.id !== result.data.updateEventCollectUserData.id
            );
          });
        }
      }
    },
    getNameByEmail(email) {
      let staff = this.hpUser.filter((staff) => staff.email === email);
      if (staff[0]) {
        return staff[0].firstName + " " + staff[0].lastName;
      }
    },
    async getUsers() {
      let that = this;
      that.hpUser = [];
      that.staff = [];
      let hpUserObj = new hpUser();
      that.hpUser = await hpUserObj.getUsers();
      that.hpUser = _.orderBy(that.hpUser, "firstName", "asc");
      that.hpUser.forEach(function (user) {
        that.staff.push({
          text: user.firstName + " " + user.lastName,
          value: user.email,
        });
      });
    },
    getSlotColour(length) {
      let colour = {};
      switch (length) {
        case 5:
          colour = "error";
          break;
        case 15:
          colour = "pink lighten-1";
          break;
        case 20:
          colour = "purple darken-1";
          break;
        case 30:
          colour = "indigo lighten-1";
          break;
        case 35:
          colour = "amber darken-1";
          break;
        case 45:
          colour = "indigo accent-2";
          break;
        case 60:
          colour = "cyan darken-2";
          break;
        default:
          colour = "info";
      }
      return colour;
    },
    showSuccessMessage(message) {
      this.message.snackbarText = message;
      this.message.snackbar = true;
    },
    compareAddressLocations(primaryLocation, assignedLocation) {
      if (primaryLocation.id === assignedLocation.eventLocationLookupId) {
        if (primaryLocation.addressLine1 !== assignedLocation.addressLine1) {
          return false; // Not comparable
        }
        if (primaryLocation.addressLine2 !== assignedLocation.addressLine2) {
          return false; // Not comparable
        }
        if (primaryLocation.town !== assignedLocation.town) {
          return false; // Not comparable
        }
        if (primaryLocation.postcode !== assignedLocation.postcode) {
          return false; // Not comparable
        }
      }
      return true; // Comparable
    },
  },
  computed: {
    computedDateFormattedMomentjs() {
      return this.eventGroup.date
        ? moment(this.eventGroup.date).format("DD/MM/YYYY")
        : "";
    },
    computedLocationsSelectOptions() {
      return this.eventLocations.map((location) => ({
        text: location.postcode,
        value: location.id,
      }));
    },
    computedListDates() {
      const groups = this.slotGroups;
      return groups.map((group) => group.date);
    },
    computedSlotGroupDates() {
      let dates = [];
      this.slotGroups.map(function (group) {
        if (!dates.includes(group.date)) {
          dates.push(group.date);
        }
      });
      return dates;
    },
  },
};
</script>
